module.exports = __webpack_public_path__ + "img/no-img.8bb57768.png";